/* eslint-disable max-lines */
/* eslint-disable no-unused-vars */

/**
 * https://github.com/validatorjs/validator.js/blob/master/src/lib/isPassportNumber.js
 * ***********************************************************************************
 * Reference:
 * https://en.wikipedia.org/ -- Wikipedia
 * https://docs.microsoft.com/en-us/microsoft-365/compliance/eu-passport-number -- EU Passport Number
 * https://countrycode.org/ -- Country Codes
 */
// const COUNTRIES = [
//   {
//     id: 'DE',
//     name: 'Alemania',
//     regex: /^[CFGHJKLMNPRTVWXYZ0-9]{9}$/
//   },
//   { id: 'DZ', name: 'Argelia', regex: /^d{9}$/ },
//   {
//     id: 'AR',
//     name: 'Argentina',
//     regex: /^[A-Z]{3}d{6}$/
//   },
//   {
//     id: 'AM',
//     name: 'Armenia',
//     regex: /^[A-Z]{2}d{7}$/
//   },
//   {
//     id: 'AU',
//     name: 'Australia',
//     regex: /^[A-Z]d{7}$/
//   },
//   {
//     id: 'AT',
//     name: 'Austria',
//     regex: /^[A-Z]d{7}$/
//   },
//   {
//     id: 'AZ',
//     name: 'Azerbaiyán',
//     regex: /^[A-Z]{2,3}d{7,8}$/
//   },
//   {
//     id: 'BE',
//     name: 'Bélgica',
//     regex: /^[A-Z]{2}d{6}$/
//   },
//   {
//     id: 'BY',
//     name: 'Bielorrusia',
//     regex: /^[A-Z]{2}d{7}$/
//   },
//   {
//     id: 'BR',
//     name: 'Brasil',
//     regex: /^[A-Z]{2}d{6}$/
//   },
//   { id: 'BG', name: 'Bulgaria', regex: /^d{9}$/ },
//   {
//     id: 'CA',
//     name: 'Canadá',
//     regex: /^[A-Z]{2}d{6}$/
//   },
//   {
//     id: 'CN',
//     name: 'China, República Popular',
//     regex: /^Gd{8}$|^E(?![IO])[A-Z0-9]d{7}$/
//   },
//   {
//     id: 'CY',
//     name: 'Chipre',
//     regex: /^[A-Z](d{6}|d{8})$/
//   },
//   {
//     id: 'KR',
//     name: 'Corea, República de',
//     regex: /^[MS]d{8}$/
//   },
//   { id: 'HR', name: 'Croacia', regex: /^d{9}$/ },
//   { id: 'DK', name: 'Dinamarca', regex: /^d{9}$/ },
//   {
//     id: 'SK',
//     name: 'Eslovaquia',
//     regex: /^[0-9A-Z]d{7}$/
//   },
//   {
//     id: 'ES',
//     name: 'España',
//     regex: /^[A-Z0-9]{2}([A-Z0-9]?)d{6}$/
//   },
//   {
//     id: 'US',
//     name: 'Estados Unidos',
//     regex: /^d{9}$/
//   },
//   {
//     id: 'EE',
//     name: 'Estonia',
//     regex: /^([A-Z]d{7}|[A-Z]{2}d{7})$/
//   },
//   {
//     id: 'RU',
//     name: 'Federacion Rusa',
//     regex: /^d{9}$/
//   },
//   {
//     id: 'PH',
//     name: 'Filipinas',
//     regex: /^([A-Z](d{6}|d{7}[A-Z]))|([A-Z]{2}(d{6}|d{7}))$/
//   },
//   {
//     id: 'FI',
//     name: 'Finlandia',
//     regex: /^[A-Z]{2}d{7}$/
//   },
//   {
//     id: 'FR',
//     name: 'Francia',
//     regex: /^d{2}[A-Z]{2}d{5}$/
//   },
//   {
//     id: 'GR',
//     name: 'Grecia',
//     regex: /^[A-Z]{2}d{7}$/
//   },
//   {
//     id: 'HU',
//     name: 'Hungría',
//     regex: /^[A-Z]{2}(d{6}|d{7})$/
//   },
//   {
//     id: 'IN',
//     name: 'India',
//     regex: /^[A-Z]{1}-?d{7}$/
//   },
//   {
//     id: 'ID',
//     name: 'Indonesia',
//     regex: /^[A-C]d{7}$/
//   },
//   {
//     id: 'IR',
//     name: 'Irán, República Islámica de',
//     regex: /^[A-Z]d{8}$/
//   },
//   {
//     id: 'IE',
//     name: 'Irlanda',
//     regex: /^[A-Z0-9]{2}d{7}$/
//   },
//   {
//     id: 'IS',
//     name: 'Islandia',
//     regex: /^(A)d{7}$/
//   },
//   {
//     id: 'IT',
//     name: 'Italia',
//     regex: /^[A-Z0-9]{2}d{7}$/
//   },
//   {
//     id: 'JM',
//     name: 'Jamaica',
//     regex: /^[Aa]d{7}$/
//   },
//   {
//     id: 'JP',
//     name: 'Japón',
//     regex: /^[A-Z]{2}d{7}$/
//   },
//   {
//     id: 'KZ',
//     name: 'Kazajistán',
//     regex: /^[a-zA-Z]d{7}$/
//   },
//   {
//     id: 'LV',
//     name: 'Letonia',
//     regex: /^[A-Z0-9]{2}d{7}$/
//   },
//   {
//     id: 'LY',
//     name: 'Libia',
//     regex: /^[A-Z0-9]{8}$/
//   },
//   {
//     id: 'LI',
//     name: 'Liechtenstein',
//     regex: /^[a-zA-Z]d{5}$/
//   },
//   {
//     id: 'LT',
//     name: 'Lituania',
//     regex: /^[A-Z0-9]{8}$/
//   },
//   {
//     id: 'LU',
//     name: 'Luxemburgo',
//     regex: /^[A-Z0-9]{8}$/
//   },
//   {
//     id: 'MY',
//     name: 'Malasia',
//     regex: /^[AHK]d{8}$/
//   },
//   { id: 'MT', name: 'Malta', regex: /^d{7}$/ },
//   {
//     id: 'MX',
//     name: 'México',
//     regex: /^d{10,11}$/
//   },
//   {
//     id: 'MZ',
//     name: 'Mozambique',
//     regex: /^([A-Z]{2}d{7})|(d{2}[A-Z]{2}d{5})$/
//   },
//   {
//     id: 'NZ',
//     name: 'Nueva Zelanda',
//     regex: /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])d{6}$/
//   },
//   {
//     id: 'NL',
//     name: 'Países Bajos',
//     regex: /^[A-Z]{2}[A-Z0-9]{6}d$/
//   },
//   {
//     id: 'PK',
//     name: 'Pakistán',
//     regex: /^[A-Z]{2}d{7}$/
//   },
//   {
//     id: 'PL',
//     name: 'Polonia',
//     regex: /^[A-Z]{2}d{7}$/
//   },
//   {
//     id: 'PT',
//     name: 'Portugal',
//     regex: /^[A-Z]d{6}$/
//   },
//   {
//     id: 'GB',
//     name: 'Reino Unido',
//     regex: /^d{9}$/
//   },
//   {
//     id: 'CZ',
//     name: 'República Checa',
//     regex: /^d{8}$/
//   },
//   {
//     id: 'TH',
//     name: 'Tailandia',
//     regex: /^[A-Z]{1,2}d{6,7}$/
//   },
//   {
//     id: 'TR',
//     name: 'Turquía',
//     regex: /^[A-Z]d{8}$/
//   },
//   {
//     id: 'UA',
//     name: 'Ucrania',
//     regex: /^[A-Z]{2}d{6}$/
//   }
// ];

// const validatePassport = str => {
//   const valid = COUNTRIES.some(country => {
//     const regex = country.regex;
//     return regex && regex.test(str);
//   });
//   return { valid };
// };

/**
 * Esta información ha sido generada con el listado de (COUNTRIES)
 * Puedes utilizar esta función para crear un listado solo de las regex.
 *
 * Ejemplo:
 *----------------------------------------------------------------
 * @param {Set}
 * const prepareData = set => {
 *  const result = [];
 *  for (const regexString of set){
 *    const regex = new RegExp(regexString.slice(1, -2));
 *    result.push(regex)
 *  }
 *   return result;
 * }
 * @param {Array}
 * const cleanDuplicate = countries => {
 *  const set = new Set();
 *  countries.forEach(countrie => {
 *    set.add(countrie.regex.toString())
 *  });
 *  return set;
 * }
 *
 * @param {Array}
 * const getRegex = countries => prepareData(cleanDuplicate(countries))
 */
const REGEXS = [
  /^[CFGHJKLMNPRTVWXYZ0-9]{9}/,
  /^d{9}/,
  /^[A-Z]{3}d{6}/,
  /^[A-Z]{2}d{7}/,
  /^[A-Z]d{7}/,
  /^[A-Z]{2,3}d{7,8}/,
  /^[A-Z]{2}d{6}/,
  /^Gd{8}$|^E(?![IO])[A-Z0-9]d{7}/,
  /^[A-Z](d{6}|d{8})/,
  /^[MS]d{8}/,
  /^[0-9A-Z]d{7}/,
  /^[A-Z0-9]{2}([A-Z0-9]?)d{6}/,
  /^([A-Z]d{7}|[A-Z]{2}d{7})/,
  /^([A-Z](d{6}|d{7}[A-Z]))|([A-Z]{2}(d{6}|d{7}))/,
  /^d{2}[A-Z]{2}d{5}/,
  /^[A-Z]{2}(d{6}|d{7})/,
  /^[A-Z]{1}-?d{7}/,
  /^[A-C]d{7}/,
  /^[A-Z]d{8}/,
  /^[A-Z0-9]{2}d{7}/,
  /^(A)d{7}/,
  /^[Aa]d{7}/,
  /^[a-zA-Z]d{7}/,
  /^[A-Z0-9]{8}/,
  /^[a-zA-Z]d{5}/,
  /^[AHK]d{8}/,
  /^d{7}/,
  /^d{10,11}/,
  /^([A-Z]{2}d{7})|(d{2}[A-Z]{2}d{5})/,
  /^([Ll]([Aa]|[Dd]|[Ff]|[Hh])|[Ee]([Aa]|[Pp])|[Nn])d{6}/,
  /^[A-Z]{2}[A-Z0-9]{6}d/,
  /^[A-Z]d{6}/,
  /^d{8}/,
  /^[A-Z]{1,2}d{6,7}/
];

const validatePassport = str => {
  const valid = REGEXS.some(regex => regex.test(str));
  return { valid };
};

export { validatePassport as default };
